import React from 'react'
import * as Yup from 'yup'
import {Formik, Form, ErrorMessage, Field} from 'formik'
import {KTSVG} from '../../../helpers'
import {postRequest} from '../../../../app/pages/Helpers/Requests'
import toast from 'react-hot-toast'

const validationSchema = Yup.object().shape({
  business_name: Yup.string().required('Business Name is required'),
  party_id: Yup.string()
    .length(3, 'Party ID must be exactly 3 characters')
    .required('Party ID is required'),
  country_code: Yup.string()
    .length(2, 'Country Code must be exactly 2 characters')
    .required('Country Code is required'),
  // versions_endpoint_url: Yup.string().url('Invalid URL').required('Versions Endpoint URL is required'),
  // token: Yup.string().required('Token is required'),
})

function AddPartner() {
  const initialValues = {
    business_name: '',
    party_id: '',
    country_code: '',
    versions_endpoint_url: '',
    token: '',
    status: 'PENDING',
  }

  const handleSubmit = async (values, {resetForm}) => {
    try {
      const res = await postRequest('/ocpi/msp', values)
      if (res && res.data) {
        toast.success(res.data.message)
        resetForm()
      }
    } catch (error) {
      console.log(error)
      toast.error(error.response.data.message)
    }
  }

  return (
    <div className='modal fade' tabIndex={-1} id='add_partner'>
      <div className='modal-dialog'>
        <div className='modal-content'>
          <div className='modal-header bg-success'>
            <h5 className='modal-title text-white'>Add Partner</h5>
            <div
              className='btn btn-icon btn-sm btn-active-light-success ms-2'
              data-bs-dismiss='modal'
              aria-label='Close'
            >
              <KTSVG
                path='/media/icons/duotune/arrows/arr061.svg'
                className='svg-icon svg-icon-2x'
              />
            </div>
          </div>
          <div className='modal-body'>
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              {({values, setFieldValue, touched}) => (
                <Form>
                  <div>
                    <div className='row'>
                      <div className='col-md-12 mt-3'>
                        <label className='form-label'>Business Name</label>
                        <Field name='business_name' className='form-control' />
                        <ErrorMessage
                          name='business_name'
                          component='div'
                          className='text-danger'
                        />
                      </div>
                      <div className='col-md-12 mt-3'>
                        <label className='form-label'>Party ID</label>
                        <Field
                          name='party_id'
                          className='form-control'
                          maxLength={3}
                          onInput={(e) => (e.target.value = e.target.value.toUpperCase())}
                        />
                        <ErrorMessage name='party_id' component='div' className='text-danger' />
                      </div>
                      <div className='col-md-12 mt-3'>
                        <label className='form-label'>Country Code</label>
                        <Field
                          name='country_code'
                          className='form-control'
                          maxLength={2}
                          onInput={(e) => (e.target.value = e.target.value.toUpperCase())}
                        />
                        <ErrorMessage name='country_code' component='div' className='text-danger' />
                      </div>
                      <div className='col-md-12 mt-3'>
                        <label className='form-label'>Versions Endpoint URL</label>
                        <Field name='versions_endpoint_url' className='form-control' />
                        <ErrorMessage
                          name='versions_endpoint_url'
                          component='div'
                          className='text-danger'
                        />
                      </div>
                      <div className='col-md-12 mt-3'>
                        <label className='form-label'>Token</label>
                        <Field name='token' className='form-control' />
                        <ErrorMessage name='token' component='div' className='text-danger' />
                      </div>
                      <div className='col-md-12 mt-3'>
                        <label className='form-label'>Select Status</label>
                        <Field as='select' name='status' className='form-control'>
                          <option value=''>Select Status</option>
                          <option value='PENDING'>PENDING</option>
                          <option value='ACTIVE'>ACTIVE</option>
                          <option value='DISABLED'>DISABLED</option>
                        </Field>
                        <ErrorMessage name='status' component='div' className='text-danger' />
                      </div>
                    </div>
                    <div className='modal-footer mt-3'>
                      <button
                        type='button'
                        className='btn btn-light-danger'
                        data-bs-dismiss='modal'
                      >
                        Cancel
                      </button>
                      <button
                        type='submit'
                        className='btn btn-light-success'
                        data-bs-dismiss='modal'
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AddPartner
